import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";

// Components
import AdminReviewersForm from "./AdminReviewersForm";
import AdminReviewersEdit from "./AdminReviewersEdit";

// State
import { addRoute } from "../../../store/actions/route";
import { setpageTitle } from "../../../store/actions/siteInfo";

class AdminReviewers extends Component {
	constructor(props) {
		super(props);
		this.props.addRoute(this.props.match);

		if (props.match.path === "/admin/reviewers/add") {
			this.props.setpageTitle("Add Reviewer");
		} else {
			this.props.setpageTitle("Edit Reviewer");
		}
	}

	// ===================================================================================
	//  RENDER
	// ===================================================================================
	render() {
		return (
			<Switch>
				<Route path={"/admin/reviewers/add"} exact component={AdminReviewersForm} />
				<Route path={"/admin/reviewers/edit"} component={AdminReviewersEdit} />
				<Route path={"/admin/reviewers"} component={AdminReviewersEdit} />
			</Switch>
		);
	}
}

export default connect(
	null,
	{ addRoute, setpageTitle }
)(AdminReviewers);



// WEBPACK FOOTER //
// ./src/components/admin/reviewers/AdminReviewers.js